export const overflow = {
  auto: 'overflow-auto',
  hidden: 'overflow-hidden',
  xAuto: 'overflow-x-auto',
  yAuto: 'overflow-y-auto',
}

export type Overflow = keyof typeof overflow
